import { View } from 'react-native';
import { crewLabels, type Crew } from '@hogar/shared';
import { Segmented, useT } from './ui';
import { setCrew, useCrew, hasGarden } from '../lib/crew';
import { useHouse } from '../lib/house';

/** "Casa | Jardín", shown only once the home has a garden. */
export function CrewSwitch() {
  const { lang } = useT();
  const house = useHouse();
  const crew = useCrew();
  if (!hasGarden(house)) return null;
  return (
    <View style={{ marginBottom: 14 }}>
      <Segmented<Crew> value={crew} options={[{ value: 'house', label: crewLabels.house[lang] }, { value: 'garden', label: crewLabels.garden[lang] }]} onChange={setCrew} />
    </View>
  );
}
